module.exports = __webpack_public_path__ + "static/media/favorite.b96d522d.svg";